<template>
<div class="nav_profile" v-click-outside="hide" @click="toggle" :id="activeStyle">
    <font-awesome-icon class="profile_icon" icon="fa-solid fa-circle-user"/>
    <span>&nbsp;{{displayName}}&nbsp;&nbsp;</span>
    <button @click="toggle" class="profile_toggle">
		<font-awesome-icon icon="fa-solid fa-caret-down" size="xs">
            </font-awesome-icon>
			<div class="dropdown" v-if="active">
            
				<a class="portal_link" href="../../portal">
                    <font-awesome-icon class="profile_icon" icon="fa-solid fa-house"/>
                    Back to Portal
                </a>
                <a class="portal_link" href="../../portal/index.php?doCmd=logout">
                    <font-awesome-icon class="profile_icon" icon="fa-solid fa-right-from-bracket"/>
                    Logout
                </a>
			</div>
	</button>
</div>

</template>

<script>
export default {
    name: "ProfileMenu",
    props:{
		name: String,
	},

    data(){
		return{
			active: false,
            displayName: null,
            activeStyle: "faded"
		}
	},
	methods: {
		toggle(){
			this.active = !this.active;
            if(this.active){
                this.activeStyle = "solid";
            }else{
                this.activeStyle = "faded";
            }
		},

        hide(){
            this.active = false;
            this.activeStyle = "faded";
        }
	},
    mounted(){
        this.displayName = this.name
    }
}
</script>

<style>
.nav_profile{
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
    padding-right: 30px;
    cursor: pointer;
    position: relative;
}

.nav_profile:hover{
    color: rgba(0, 0, 0, 1)
}

.profile_icon{
    color: rgb(0, 0, 0)!important;
}

.dropdown{
    box-sizing: border-box;
    display: block;
    float: none;
    left: -7px;
    margin-bottom: 0px;
    margin-left: -16px;
    margin-right: 0px;
    margin-top: 2px;
    min-width: 160px;
    padding-bottom: 8px;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 8px;
    position: absolute;
    top: 30px;
    z-index: 1000;

    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    text-size-adjust: 100%;

    color: rgb(33, 37, 41);
    background-clip: padding-box;
    background-color: rgb(255, 255, 255);
    border-bottom-color: rgba(0, 0, 0, 0.15);
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-image-outset: 0;
    border-image-repeat: stretch;
    border-image-slice: 100%;
    border-image-source: none;
    border-image-width: 1;
    border-left-color: rgba(0, 0, 0, 0.15);
    border-left-style: solid;
    border-left-width: 1px;
    border-right-color: rgba(0, 0, 0, 0.15);
    border-right-style: solid;
    border-right-width: 1px;
    border-top-color: rgba(0, 0, 0, 0.15);
    border-top-style: solid;
    border-top-width: 1px;

    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    list-style-image: none;
    list-style-position: outside;
    list-style-type: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.dropdown:focus{
    color: rgb(0, 0, 0)
}
.portal_link{
    box-sizing: border-box;
    clear: both;
    display: block;
    height: 32px;
    padding-bottom: 4px;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 4px;
    width: 167.344px;

    color: rgb(0, 0, 0)!important;
}

.portal_link:hover{
    background-color: rgb(248, 249, 250);
}

#solid{
    color: rgba(0, 0, 0, 1);
}
</style>